import { Divider, Grid, Text } from '@wework/dieter-ui'
import LinkRoom from '../SidebarBlocks/LinkRoom'
import React from 'react'
import {
  CheckIsDedicatedDesk,
  CheckIsHotDesk,
} from '../../utils/EntitySynonyms'
import ProductType from '../SidebarBlocks/ProductType'
import EditProductAttributes from './EditProductAttributes'
import EditProductMeetingRoomAttributes from './EditProductMeetingRoomAttributes'

export default function EditProductMeetingRoom({
  space,
  roomData,
  setRoomData,
}) {
  const getEditingProductSection = () => {
    switch (space?.programType) {
      case 'MEET':
        return (
          <EditProductMeetingRoomAttributes
            space={space}
            roomData={roomData}
            setRoomData={setRoomData}
          />
        )
      case 'WORK':
        if (space.roomType === 'CHAIR') {
          return <p></p>
        } else {
          return (
            <EditProductAttributes
              space={space}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          )
        }
      default:
        return <p></p>
    }
  }
  if (!space) {
    return null
  }
  return (
    <div>
      <Grid style={{ marginTop: 24 }}>
        <Grid.Row stretched>
          <Grid.Column>
            <div>
              <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                Inventory
              </Text>
            </div>
          </Grid.Column>
        </Grid.Row>
        {!CheckIsHotDesk(space.subType.toUpperCase()) &&
          !CheckIsDedicatedDesk(space.subType.toUpperCase()) && (
            <>
              <LinkRoom space={space} />
              <Divider light style={{ width: '100%' }} />
            </>
          )}
        <ProductType
          space={space}
          setRoomData={setRoomData}
          roomData={roomData}
        />
      </Grid>
      {space.inventoryData && space.inventoryData?.relationships?.length > 0 ? (
        <>
          <Divider light style={{ width: '100%' }} />
          <Grid>
            <Grid.Row>
              <Grid.Column style={{ paddingRight: '0' }}>
                <div>
                  <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                    Details
                  </Text>
                  <Text style={{ paddingBottom: '20px', fontSize: 14 }}>
                    Manage inventory by keeping the data up to date. Some
                    changes require approval.
                  </Text>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {getEditingProductSection()}
        </>
      ) : (
        <>
          <Grid>
            <Grid.Row>
              <Grid.Column style={{ paddingRight: '0' }}>
                <div>
                  <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                    Details
                  </Text>
                  <Text
                    size="tiny"
                    style={{ backgroundColor: '#F7F7F7', padding: '16px' }}
                  >
                    ⚠️ Link inventory to this space and you’ll be able to
                    view/update the inventory information here.
                  </Text>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </>
      )}
    </div>
  )
}
